import React, { FunctionComponent } from 'react';
import './RulesAndTemplates.scss';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { COUNTRIES } from '../../utils/consts';
import { useAnalyticsEventTracker } from '../../analytics/analytics';
import {Layout} from '@iba-team/portal-react-components/dist';
export const RulesAndTemplates: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const gaEventTracker = useAnalyticsEventTracker('Help_countries');
  const onCountryClick = (i: {name: string, link: string}) => {
    gaEventTracker('select_country', i.name);
    navigate(i.link);
  };

  return (
    <>
      <Layout  className='rules' header={{layoutName: <h3>{t('rulesTitle')}</h3>}}>
        <div className="rules__link-wrapper">
          { COUNTRIES.map(i => (
            <div key={i.name} className='rules__link' onClick={() =>  onCountryClick(i) }>{ i.name }</div>
          ))}
        </div>
      </Layout>
      <Outlet/>
    </>
  );
};
